module.exports = __webpack_public_path__ + "static/media/spirit_breaker.b6eb4375.png";